<template>
  <footer class="footer">
    <div class="footer-primary container">
    </div>
      <div class="footer-bottom">

          <div class="container">

              <div class="company-container">

                  <div class="photo-info-area">
                    <p>Na fotografii Szolka, projektu Bogdana Kosaka, z grafiką koncepcji Gryfnie.</p>
                  </div>

                  <div class="company-copyrights">
                    <p>Kontur.IT Sp. z o.o. - ul. Szenwalda 12, 44-113 Gliwice
                      , tel. 
                      <span v-if="!phoneNumber" ref="number" class="show-number" v-on:click="getNumber" style="cursor:pointer">pokaż numer</span>
                      <a v-if="phoneNumber" href="tel:+48322790616">32 279 06 16</a>
                      , e-mail: <a href="mailto:biuro@kontur.it">biuro@kontur.it</a></p>
                  </div>
                  <div class="footer-bottom-links">
                    <div class="footer-bottom-links-text">Wszelkie prawa zastrzeżone © 2020</div>
                    <router-link to="/polityka-prywatnosci" title="Polityka prywatności">
                        Polityka prywatności            </router-link>
                    <router-link to="/mapa-strony" title="Mapa strony">
                    Mapa strony            </router-link>
                  </div>
              </div>
          </div>

      </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data: function () {
    return {
      phoneNumber: false
    }
  },
  methods: {
    getNumber: function () {
      this.phoneNumber=true;
    }
  }
}
</script>